import { StandardLoanDetails } from '../../../../../../queries/standardLoanQueries';
import { BorrowerType } from '../../../../../../../../../common/components/v2/BorrowerSelector/constants/borrowerSelection';
import { BorrowerForm, BorrowerLoanContext } from '../constants/borrowerForm';

/**
 * The Borrower section's form and context for a loaded loan, following EditStdLoanModal's populateState: a loan with a
 * B-Client agreement is "Borrower with B-Client", anything else "Borrower Only". A new loan opened for a B-Client has
 * its borrower locked.
 */
export const getBorrowerFromLoan = (loan: StandardLoanDetails, isForBClient: boolean) => {
    const borrower: BorrowerForm = {
        borrowerType: loan.brokerAgreementId ? BorrowerType.BClient : BorrowerType.Entity,
        borrowerEntityId: loan.borrowerEntityId ?? undefined,
        brokerAgreementId: loan.brokerAgreementId ?? undefined,
        brokerId: loan.brokerId ?? undefined,
    };

    const borrowerLoanContext: BorrowerLoanContext = {
        brokerAgreementLocked: isForBClient,
    };

    return { borrower, borrowerLoanContext };
};
